<template>
    <b-container id="content" fluid class="">
        <b-row>
            <b-col md="3" lg="4">
            </b-col>
            <b-col id="loginCol" class="bg-dark text-light
                mx-3 mx-md-0 px-0"
                :style=" {'height' : window.height + 'px' }">
                <figure class="d-none d-md-block">
                    <img id="logo-cp"
                    src="../../assets/logo-cp.svg" alt="CentrePark Logo"
                    >
                </figure>
                <h2 id="title" class="mt-lg-3 mx-lg-3 
                    mt-3 mx-3 mb-3
                    text-center">
                    CentrePark Monitoring Services
                </h2>
                <div id="LoginCard" no-body class="mx-4">                    
                    <b-form @submit.prevent="validateInput">
                        <fieldset id="form">
                            <legend class="h6">Login</legend>
                            <v-input v-for="login in formLogin"
                                :type="login.type"
                                :required="login.required"
                                :label="login.label"
                                :placeholder="login.placeholder"
                                ></v-input>
                            <v-btn type="submit" 
                            class="mt-1"
                            block="true" size="md">Sign in</v-btn>
                            <div class="col-md-12 item-center text-center">
                                <a class="text-white" href="../centreparkdashboard/dashboard/reset-season.php" role="button">Reset Season</a>
                            </div>
                        </fieldset>
                    </b-form>
                    <b-alert class="mt-3"
                        :show="alert.show" :variant="alert.variant">
                        <h6 class="text-center">{{alert.title}}</h6>
                        <p class="text-center text-justify">
                            {{alert.msg ? alert.msg : null}}
                        </p>
                    </b-alert>
                </div>
            </b-col>
            <b-col md="3" lg="4"></b-col>
        </b-row>
    </b-container>
</template>


<script>

    import input from "@/components/Forms/v-form-login.vue" //include file
    import btn from "@/components/v-button.vue" //include file

    export default {
        data() {
            return {
                apiURL: process.env.VUE_APP_API_FILEPATH,
                hostname: process.env.VUE_APP_HOSTNAME,
                dashboardURL: process.env.VUE_APP_DASHBOARD_FILEPATH,
                window: {
                    width: 0,
                    height: 0
                },
                formLogin: [{
                    required: true,
                    label: "Email",
                    placeholder: "Your email..",
                    type: "email",
                }, {
                    required: true,
                    label: "Password",
                    placeholder: "Password..",
                    type: "password",
                }],
                alert: {
                    show: false,
                    variant: '',
                    title: '',
                    msg: ''
                }
            }
        },
        components: {
            "v-input": input,
            "v-btn": btn
        },
        methods: {
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            getInputs(childs){
                return childs = childs.filter( (child, i, arr) => {
                    return typeof (child.label) !== "undefined"
                }).map( (child, i, arr) => {
                    return child.input
                })
            },
            validateInput(event){
                this.input = this.getInputs(this.$children)
                this.alert.variant = "primary"
                this.alert.title = "Loading.."
                this.alert.msg = ""
                this.alert.show = true
                setTimeout( () => {
                    axios.post(this.apiURL + "login.php", {
                        input: this.input        
                    })
                    .then( (res) => {
                        this.InputValidation = res.data
                        if(this.InputValidation.error) throw this.InputValidation
                        else location.href = this.dashboardURL+"/"+res.data
                        // console.log(res.data)
                    })
                    .catch( (err) => {
                        event.preventDefault();
                        this.alert.variant = "danger"
                        this.alert.title = err.title
                        this.alert.msg = err.message
                        this.alert.show = true
                        // console.log(this.alert.msg)
                    })
                }, 150)
                // On submit, if true => 
                    // if group === CentrePark member => head to dashboard 
                    // else => head to charts
                // else if false alert user
                    // Delete written email and password?
            },
            checkSession(){
                setTimeout( () => {
                    axios.post(this.apiURL + "session.php", {
                        input: this.input        
                    })
                    .then( (res) => {
                        this.InputValidation = res.data
                        if(this.InputValidation.error) 
                            throw this.InputValidation
                        else if(this.InputValidation.filepath === "config.php") {
                            location.href = this.dashboardURL+"/"+
                                this.InputValidation.filepath
                        }
                        else if(this.InputValidation.success === true) {
                            this.alert.variant = "success"
                            this.alert.title = this.InputValidation.title
                            this.alert.msg = this.InputValidation.message
                            this.alert.show = true
                        }
                    })
                    .catch( (err) => {
                        event.preventDefault();
                        this.alert.variant = "danger"
                        this.alert.title = err.title
                        this.alert.msg = err.message
                        this.alert.show = true
                    })
                }, 0)
            }
        },
	/*beforeCreate () {
	    location.redirect('http://dashboard.centrepark.co.id/centreparkdashboard/dashboard/daily-income.php')
	},*/
        created(){
            this.checkSession();
            window.addEventListener('resize', this.handleResize)
            this.handleResize();
        },
        mounted() {

        }
    }
</script>

<style scoped>
#content {
    /*background-color: rgb(32,19,255);*/
}
#loginCol {
    box-shadow: 0 0 34px #555;
}
#LoginCard {
    box-shadow: 0 0 21px #555,
                /*0 0 21px #000;*/
}
#title {
    /*text-shadow: 1px 1px 2px #000;*/
}
figure {
    /* Margins */
    margin-top: 0.5em;
    margin-left: -3%;
    margin-right: -3%;
    /* Paddings */
    padding: 0.5rem 1rem;
    background-color: rgb(243,243,243);
    border-radius: 1%;
    box-shadow: 0 3px 21px #000;
}
figure img{
   display:block; /*remove inline-block spaces*/
   margin: 0 auto;
   height: 69px;
}
#form {
    border: 3px groove #ddd !important;
    padding: 0 1.3em 1.3em 1.3em !important;
    margin: 0 0 0em 0 !important;
    -webkit-box-shadow:  0px 0px 0px 0px #000;
            box-shadow:  0px 0px 0px 0px #000;
}
#form legend {
    text-align: left !important;
    width:auto;
    padding:0 10px;
    border-bottom:none;
}
button.btn {

}
</style>